import {Modal} from 'react-bootstrap';
import * as Styled from './PromptModalStyles';
import closeIcon from '../../../images/close-icon.svg';
import React from 'react';

interface PromptModalProps{
  open: boolean,
  message: any,
  onClose: Function,
  buttonTxt?: string,
  buttonHref?:string,
}
const PromptModal = ({
  open,
  message,
  onClose,
  buttonTxt,
  buttonHref,
}:PromptModalProps) => {

  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      size='sm'
      contentClassName='custom-content'
      dialogClassName='custom-dialog'
    >
      <Styled.ModalBody>
        <Styled.ModalClose onClick={onClose} className='HeaderBtn'>
          <Styled.CloseImg src={closeIcon} alt='Close' />
        </Styled.ModalClose>
        {message}
      </Styled.ModalBody>
      {buttonTxt && (
        <Styled.ModalFooter>
          <Styled.StyledModalBtn href={buttonHref || ''} onClick={onClose}>
            {buttonTxt}
          </Styled.StyledModalBtn>
        </Styled.ModalFooter>
      )}
    </Modal>
  )
}

export default PromptModal;